// columns pour le tableau des produits afin d'integrer le css de tableau styles 
import { Hotel, Mountain, Plane, Car, Home, PackageOpen, HelpCircle } from 'lucide-react';
import {
  serviceTypeStyle,
  supplierStyle,
  statusStyle,
  activeStatusStyle,
  getCompletionColor
} from './tableStyles';

// Add truncation with hover tooltip
const TruncatedCell = ({ value, maxLength = 30 }) => {
  if (!value) return value;
  
  const shouldTruncate = value.length > maxLength;
  const truncatedText = shouldTruncate 
    ? `${value.substring(0, maxLength)}...` 
    : value;

  return (
    <div 
      style={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: shouldTruncate ? 'help' : 'default'
      }}
      title={shouldTruncate ? value : ''} // This adds the hover tooltip
    >
      {truncatedText}
    </div>
  );
};

export const getServiceIcon = (serviceType) => {
  switch (serviceType) {
    case 'hotel': return <Hotel size={16} />;
    case 'activity': return <Mountain size={16} />;
    case 'flight': return <Plane size={16} />;
    case 'transfer': return <Car size={16} />;
    case 'package': return <PackageOpen size={16} />;
    case 'hosting': return <Home size={16} />;
    default: return <HelpCircle size={16} />;
  }
};

export const makeColumns = (t) => [
  {
    key: 'id',
    label: 'ID',
    render: (value) => `#${value}`
  },
  {
    key: 'product',
    label: t('product'),
    render: (value) => <TruncatedCell value={value} maxLength={25} />
  },
  {
    key: 'serviceType',
    label: t('service'),
    render: (value) => (
      <div style={serviceTypeStyle.container}>
        {getServiceIcon(value)}
        {t(value)}
      </div>
    )
  },
  {
    key: 'supplier',
    label: t('supplier'),
    render: (value, row) => (
      <div>
        <div>{value}</div>
        <div style={supplierStyle.phone}>{row.phone}</div>
      </div>
    )
  },
  {
    key: 'location',
    label: t('location'),
    render: (value) => <TruncatedCell value={value} maxLength={25} />
  },
  {
    key: 'status',
    label: t('status'),
    render: (value) => (
      <span style={statusStyle(value)}>
        {t(value)}
      </span>
    )
  },
  {
    key: 'activeStatus',
    label: t('activeStatus'),
    render: (value) => (
      <span style={activeStatusStyle(value)}>
        {t(value)}
      </span>
    )
  },
  {
    key: 'completion',
    label: t('completion'),
    render: (value) => {
      const color = getCompletionColor(value);
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          width: '100%',
        }}>
          {/* La barre */}
          <div style={{
            flex: 1,
            height: '8px',
            background: '#e5e7eb',
            borderRadius: '4px',
            overflow: 'hidden',
          }}>
            <div style={{
              maxWidth: `${value}%`,
              height: '100%',
              background: color,
            }} />
          </div>

          {/* Le pourcentage */}
          <span style={{
            fontSize: '12px',
            color: '#6b7280',
            minWidth: '15px',
            textAlign: 'right',
            display: 'block'
          }}>
            {value}%
          </span>
        </div>
      );
    }
  }
];